import { AxiosError } from 'axios';
import { ErrorHandler } from '@/services/errorHandler/types';

export default class BaseErrorHandler implements ErrorHandler {
  handle = (error: AxiosError): string => {
    let msg;
    if (error.response) {
      msg = error.response.status;
    } else if (error.request) {
      msg = error.request;
    } else {
      msg = error.message;
    }
    return `errorStatusMessage.${msg}`;
  };
}
